import React from 'react';
import { Alert } from 'antd';

const AppointmentActionAlert = ({ message }: { message: string }) => <Alert message={message} type="info" showIcon />;

export default AppointmentActionAlert;
